<template>
    <site-layout>
        <base-message v-if="succeed == null" type="is-success">
            <strong>Verifying...</strong>
        </base-message>

        <base-message v-else-if="succeed" type="is-info">
            <strong>Congratulations!</strong>
        </base-message>

        <base-message v-else type="is-danger">
            <strong>Expired/wrong confirmation address.</strong>
        </base-message>

        <base-button
            v-if="succeed"
            icon="fas fa-chart-bar"
            class="is-primary is-fullwidth"
            :to="{name: 'spaces'}"
            text="Go to dashboard"/>

        <base-button
            icon="fas fa-arrow-left"
            class="is-fullwidth"
            :to="{name: 'home'}"
            text="Back home"/>
    </site-layout>
</template>

<script>
import { mapState } from 'vuex';
import SiteLayout from '../components/layouts/SiteLayout.vue';

export default {
    name: 'Confirm',
    components: { SiteLayout },
    computed: mapState('confirm', ['succeed']),
    created() {
        this.$store.dispatch('confirm/confirm', this.$route.params.code);
    },
};
</script>
